<div class="wrap">
  <ng-container *ngFor="let m of menu">
    <mat-card
      appearance="outlined"
      [ngSwitch]="m?.iconType"
      [routerLink]="[m.url]"
      routerLinkActive="router-link-active"
      class="card_active"
    >
      <div class="header">
        <fa-icon *ngSwitchCase="'faIcon'" [icon]="getIcon(m?.icon)"></fa-icon>
      </div>
      <mat-card-content>
        <h3>{{ m.appName }}</h3>
        <!-- <p> -->
        {{ m.description }}
        <!-- </p> -->
      </mat-card-content>
    </mat-card>
  </ng-container>
</div>
